import { useState, useCallback, type FunctionComponent } from 'react';
import { useParams } from 'react-router-dom';
import { ZoomCall as SharedZoomCall } from '@qler-view/shared_lib/src/shared/zoom';
import ChatQLER from '@qler-view/shared_lib/src/shared/Chat/ChatQLER';
import { useChatNotifications } from '@qler-view/shared_lib/src/shared/Chat/useChatNotifications';
import { PORTAL_TYPES } from '@qler-view/shared_lib/src/shared/constants/portalType';
import { zoomHooks } from '../../shared/zoom/zoomSetup';
import {
  useGetAcsChatToken,
  useGetConsultChatThread,
} from '../../API/hooks/acsChatHook';
import { getUserFromStorage } from '../components/storageUtility';

const ZOOM_SDK_KEY = import.meta.env.VITE_ZOOM_SDK_KEY;

const ZoomCall: FunctionComponent = () => {
  const { caseId } = useParams();
  const consultId = Number.parseInt(caseId ?? '0');
  const user = getUserFromStorage();
  const userId = user?.userId ?? 0;

  const [isChatOpen, setIsChatOpen] = useState(false);

  const { acsChatToken } = useGetAcsChatToken(userId, PORTAL_TYPES.FACILITY);
  const { consultChatThread } = useGetConsultChatThread(
    consultId,
    userId,
    PORTAL_TYPES.FACILITY,
    isChatOpen
  );

  const handleChatToggle = useCallback((isOpen: boolean) => {
    setIsChatOpen(isOpen);
  }, []);
  const { incrementUnread } = useChatNotifications(true);

  const displayName =
    `${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim() || 'User';

  const chatPanelNode = (
    <ChatQLER
      acsConfig={
        acsChatToken
          ? {
              endpoint: import.meta.env.VITE_ACS_ENDPOINT,
              token: acsChatToken.token,
              userId: acsChatToken.acsUserId,
              displayName: displayName,
              portalType: PORTAL_TYPES.FACILITY,
            }
          : undefined
      }
      threadId={consultChatThread?.threadId}
      subtitle={consultChatThread?.participants || ''}
      onNewMessage={incrementUnread}
    />
  );

  return (
    <SharedZoomCall
      zoomSdkKey={ZOOM_SDK_KEY}
      zoomHooks={zoomHooks}
      chatPanel={chatPanelNode}
      portalType={PORTAL_TYPES.FACILITY}
      userId={userId}
      onChatToggle={handleChatToggle}
    />
  );
};

export default ZoomCall;
